<date-input
    [showTimePicker]="dateSettings && dateSettings.allowTimeInput"
    [(value)]="answer"
    (valueChange)="fieldChange()"
    [disabled]="readonly"
>
</date-input>
